import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=700a4820"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorModal.vue?vue&type=style&index=0&id=700a4820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports